import { createAction, props } from "@ngrx/store";
import { User, PagedUsers } from "../../models/users.model";


export const loadUsers = createAction(
    '[Users] Load Users',
    props<{ page: number, limit: number, query?: string }>()
);

export const loadUsersSuccess = createAction(
    '[Users] Load Users Success',
    props<{ users: PagedUsers }>()
);

export const loadUsersFailure = createAction(
    '[Users] Load Users Failure',
    props<{ error: any }>()
);

export const updatedUser = createAction(
    '[Users] Update User',
    props<{ user: User }>()
);

export const createUser = createAction(
    '[Users] Create User',
);

export const createUserSuccess = createAction(
    '[Users] Create User Success',
    props<{ user: User }>()
);

export const createUserFailure = createAction(
    '[Users] Create User Failure',
    props<{ error: any }>()
);

export const editUser = createAction(
    '[Users] Edit User',
);

export const editUserSuccess = createAction(
    '[Users] Edit User Success',
    props<{ user: User }>()
);

export const editUserFailure = createAction(
    '[Users] Edit User Failure',
    props<{ error: any }>()
);

export const deleteUser = createAction(
    '[Users] Delete User',
    props<{ id: number }>()
);

export const deleteUserSuccess = createAction(
    '[Users] Delete User Success',
    props<{ id: number }>()
);

export const deleteUserFailure = createAction(
    '[Users] Delete User Failure',
    props<{ error: any }>()
);

export const loadUserById = createAction(
    '[Users] Load User By Id',
    props<{ id: number }>()
);

export const loadUserByIdSuccess = createAction(
    '[Users] Load User By Id Success',
    props<{ user: User }>()
);

export const loadUserByIdFailure = createAction(
    '[Users] Load User By Id Failure',
    props<{ error: any }>()
);


